import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=1d2e498a&scoped=true&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=1d2e498a&prod&scoped=true&lang=scss&"
import style1 from "./ProductCard.vue?vue&type=style&index=1&id=1d2e498a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2e498a",
  null
  
)

export default component.exports